import React from 'react';
import TextField from 'material-ui/TextField';

const style = {
  fontFamily: 'Lato',
  marginBottom: '14px',
};

const StyledTextField = (props) => (
  <TextField
    {...props}
    style={{
      ...style,
      ...props.style,
    }}
  />
);

export default StyledTextField;



// WEBPACK FOOTER //
// ./components/atoms/TextField.js